
import clsx from "clsx";
import React from "react";


const estilosInputs = require('../../../estilos/inputs.module.scss').default
const estilosBotoes = require("../../../estilos/botoes.module.scss").default;
const estiloTabela = require('../../../estilos/tabelas.module.scss').default


declare const window: any;


export type PesquisaOrdermProducaoProps = {
    onOk: () => void
    onPesquisar: () => void
}

export const PesquisaOrdermProducao = (props: PesquisaOrdermProducaoProps) => {

    const headerTabela = () => {
        const mapHeader = ["Ordem produção", "Data Inclusão", "Data Aprovação", "Produto"]

        return mapHeader.map((nome) => <th key={nome} className={`_table-cell`}>{nome}</th>)
    }

    return (
        <>
            <div className="_flex _items-center _mt-2 _w-full _bg-[#e4e6e8] _py-2">
                <div className="_text-center _w-full">
                    <p className="_font-bold _mb-0">Pesquisa de Ordem de Produção</p>
                </div>
            </div>

            <div className="_mt-4 _mb-8">
                <div className="_flex _my-2">
                    <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Ordem de Produção</label>
                    <input
                        type="text"
                        className={estilosInputs.inputPadrao}
                    />
                </div>
                <div className="_flex _my-2">
                    <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Data de Inclusão Inicial</label>
                    <input
                        type="text"
                        className={clsx("_w-[100px]", estilosInputs.inputPadrao)}
                    />
                </div>
                <div className="_flex _my-2">
                    <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Data de Inclusão Final</label>
                    <input
                        type="text"
                        className={clsx("_w-[100px]", estilosInputs.inputPadrao)}
                    />
                </div>
                <div className="_flex _my-2">
                    <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Data de Aprovação Inicial</label>
                    <input
                        type="text"
                        className={clsx("_w-[100px]", estilosInputs.inputPadrao)}
                    />
                </div>
                <div className="_flex _my-2">
                    <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Data de Aprovação Final</label>
                    <input
                        type="text"
                        className={clsx("_w-[100px]", estilosInputs.inputPadrao)}
                    />
                </div>
                <div className="_flex _my-2">
                    <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Situação</label>
                    <select
                        className={clsx("_w-[300px]", estilosInputs.inputPadrao)}

                    >
                    </select>
                </div>
                <div className="_flex _my-2">
                    <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Pedido de Venda</label>
                    <input
                        type="text"
                        className={clsx("_w-[100px]", estilosInputs.inputPadrao)}
                    />
                </div>
                <div className="_flex _my-2">
                    <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Produto</label>
                    <input
                        type="text"
                        className={clsx("_w-[400px]", estilosInputs.inputPadrao)}
                    />
                </div>
            </div>


            <div className="_my-4">
                <div className="_justify-between">
                    <div className="_my-4">
                        <button className={`_flex _my-2 no-global-button ${estilosBotoes.botaoPrimario}`}
                            onClick={() => { props.onPesquisar() }}
                        >
                            Pesquisar
                        </button>
                    </div>
                </div>
            </div>

            <div className="_my-4">
                <table className={`_table _w-full _border-collapse ${estiloTabela.tabela}`}>
                    <thead className="_table-header-group"> 
                        <tr className="_table-row">
                            {headerTabela()}
                        </tr>
                    </thead>
                </table>
            </div>

            <div className="_my-4">
                <div className="_justify-between">
                    <div className="_my-4">
                        <button className={`_flex _my-2 no-global-button ${estilosBotoes.botaoPrimario}`}
                            onClick={() => { props.onOk() }}
                        >
                            Ok
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}